/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import a11yKeyPress from 'js/lib/a11yKeyPress';

import { Grid } from '@coursera/cds-core';
import { SvgChevronDown } from '@coursera/coursera-ui/svg';

import PartnerSelectionMenu from 'bundles/admin-v2/components/PartnerSelectionMenu';
import type { Partner } from 'bundles/admin-v2/constants/types';

import PartnerDefaultLogo from 'images/admin/partner_logo_placeholder.svg';

import _t from 'i18n!nls/admin-v2';

const styles = {
  universityLogo: css`
    margin: var(--cds-spacing-400) var(--cds-spacing-300);
  `,
  universityLogoImage: css`
    min-height: 30px;
    max-height: 42px;
    max-width: 200px;
    min-width: 30px;
    margin-right: var(--cds-spacing-150);
  `,
  partnerName: css`
    margin-top: var(--cds-spacing-200);
  `,
};

type InputProps = {
  selectedPartner: Partner;
  selectedPartnerId: number;
  partners: Partner[] | undefined;
};

type Props = InputProps;

const PartnerSelectionButton: React.FC<Props> = ({ selectedPartnerId, selectedPartner, partners }) => {
  const { partnerName, rectangularLogo, logo } = selectedPartner;
  const logoSrc = rectangularLogo || logo;
  const [showSelectionMenu, setShowSelectionMenu] = React.useState(false);

  const hasMultiplePartners = () => partners && partners.length > 1;
  const hasLogo = () => logoSrc !== undefined && logoSrc !== '';

  const handleClick = () => {
    setShowSelectionMenu(true);
  };

  return (
    <React.Fragment>
      <div
        css={styles.universityLogo}
        onClick={handleClick}
        onKeyPress={(e) => a11yKeyPress(e, handleClick)}
        role="button"
        tabIndex={0}
      >
        <Grid container justifyContent="space-between" alignItems="center" direction="row">
          <div css={!hasLogo() && styles.universityLogoImage}>
            <img src={logoSrc || `${PartnerDefaultLogo}`} alt={partnerName} css={styles.universityLogoImage} />
          </div>
          {hasMultiplePartners() && <SvgChevronDown size={24} />}
        </Grid>
        <Grid css={styles.partnerName} container justifyContent="space-between" alignItems="center" direction="row">
          <strong>{_t('#{name}', { name: partnerName })}</strong>
        </Grid>
      </div>

      <PartnerSelectionMenu
        showSelectionMenu={showSelectionMenu}
        selectedPartnerId={selectedPartnerId}
        partners={partners}
        onBlur={() => {
          setShowSelectionMenu(false);
        }}
      />
    </React.Fragment>
  );
};

export default PartnerSelectionButton;
